import { ActivityLogType } from "../../../../../../../../utils/constants";
import { CustomLogTypography, EntityLink } from "./utils";

export default function getScanLogContent(log) {
  if (log.log_type === ActivityLogType.NEW_GAP)
    return (
      <CustomLogTypography>
        Control discovered, status is Gap
      </CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.NEW_COMPLIANT)
    return (
      <CustomLogTypography>
        Control discovered, status is Compliant
      </CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.TURNED_GAP)
    return <CustomLogTypography>Control turned Gap</CustomLogTypography>;

  if (log.log_type === ActivityLogType.TURNED_COMPLIANT)
    return <CustomLogTypography>Control turned Compliant</CustomLogTypography>;

  if (log.log_type === ActivityLogType.APPLICABLE_GAP)
    return (
      <CustomLogTypography>Control applicable, status Gap</CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.APPLICABLE_COMPLIANT)
    return (
      <CustomLogTypography>
        Control applicable, status Compliant
      </CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.NOT_APPLICABLE)
    return (
      <CustomLogTypography>Control no longer applicable</CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.IMPROVED) {
    const changedEntitiesCount =
      log.entities_before_count - log.entities_after_count;
    return (
      <CustomLogTypography>
        Control improved — {changedEntitiesCount} fewer misconfigured{" "}
        {changedEntitiesCount === 1 ? "entity" : "entities"}
      </CustomLogTypography>
    );
  }

  if (log.log_type === ActivityLogType.ESCALATED) {
    const changedEntitiesCount =
      log.entities_after_count - log.entities_before_count;
    return (
      <CustomLogTypography>
        Control escalated — {changedEntitiesCount} new misconfigured{" "}
        {changedEntitiesCount === 1 ? "entity" : "entities"}
      </CustomLogTypography>
    );
  }

  if (log.log_type === ActivityLogType.CONTROL_SNOOZE_ENDED)
    return (
      <CustomLogTypography>
        Snooze period for control has ended
      </CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.ENTITY_SNOOZE_ENDED) {
    return (
      <CustomLogTypography>
        Snooze period for{" "}
        <EntityLink log={log} entityId={log.entity_id}>
          {log.entity_display_name}
        </EntityLink>{" "}
        has ended
      </CustomLogTypography>
    );
  }
  return null;
}
